<script>
import { mapActions } from 'vuex';
import ApprovalButton from './approval-button.vue';

export default {
    props: {
        input: {
            type: Object,
            required: true
        },
    },

    components: {
        ApprovalButton,
    },

    data() {
        return {
            documents: [],

            input_headers: [
                { key: 'name', text: null, flex: 6 },
                { key: 'year', text: this.$t('approval.headers.year'), flex: 2 },
                { key: 'quarter', text: this.$t('approval.headers.quarter'), flex: 2 },
                { key: 'value', text: this.$t('approval.headers.value'), flex: 4 },
                { key: 'approval_status', text: this.$t('approval.headers.approval_status'), flex: 6 },
            ],
            
            document_headers: [
                { key: 'name', text: this.$t('approval.headers.document_name'), flex: 0.5 },
                { key: 'view', text: this.$t('approval.headers.view'), flex: 0.2 },
                { key: 'approval_status', text: this.$t('approval.headers.approval_status'), flex: 0.3 },
            ],
        }
    },

    mounted() {
        this._getDocumentsByMetric();
    },

    methods: {
        ...mapActions('approvals', [
            'getDocumentsByMetric',
            'approveEntity',
        ]),

        _approveInput(action) {
            const params = {
                type: this.input.type,
                body: {
                    relevant_id: this.input.metrics_input_table_id,
                    status: action,
                    document_id: null,
                    company_id: this.input.company_id,
                    facility_id: this.input.facility_id,
                    year: this.input.year,
                    quarter: this.input.quarter,
                },
            };

            this.approveEntity(params)
                .then(res => {
                    if (!this.input.approval_status) {
                        this.input.approval_status = {
                            status: action,
                            last_edited_by: `${this.$user.firstname} ${this.$user.surname}`,
                            last_edited_on: new Date(),
                        };
                        this.$emit('update_input', {
                            ...this.input,
                            approval_status: {
                                status: action,
                                last_edited_by: `${this.$user.firstname} ${this.$user.surname}`,
                                last_edited_on: new Date(),
                            },
                        });
                    } else {
                        this.input.approval_status.status = action;
                        this.input.approval_status.last_edited_by = `${this.$user.firstname} ${this.$user.surname}`;
                        this.input.approval_status.last_edited_on = new Date();
                    }
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        ...mapActions('documents', [
            'viewDocument',
        ]),

        _getDocumentsByMetric() {
            const params = {
                type: this.input.type,
                input_id: this.input.metrics_input_table_id,
            };

            this.getDocumentsByMetric(params)
                .then(res => {
                    this.documents = res.data;
                })
                .catch(({ response }) => {
                    console.error(response.data.messageName);
                })
        },

        _approveDocument(action, document) {
            const params = {
                type: `${this.input.type}_document`,
                body: {
                    relevant_id: this.input.metrics_input_table_id,
                    status: action,
                    document_id: document.id,
                    company_id: this.input.company_id,
                    facility_id: this.input.facility_id,
                    year: this.input.year,
                    quarter: this.input.quarter,
                },
            };

            this.approveEntity(params)
                .then(res => {
                    document['approval_status'].status = action;
                    document['approval_status'].last_edited_by = `${this.$user.firstname} ${this.$user.surname}`,
                    document['approval_status'].last_edited_on = new Date(),
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
    }
}
</script>

<template>
    <div class="flex-all-centered-col">
        <div class="flex-all-centered-row headers">
            <div v-for="h in input_headers" :key="h.key"
                :style="{ flex: h.flex }"
            >
                <span v-if="h.key === 'name'">{{ $t(`approval.headers.${input.type}_name`) }}</span>
                <span v-else>{{ h.text }}</span>
            </div>
        </div>
        <div class="flex-all-centered-row values">
            <div v-for="h in input_headers" :key="h.key"
                :style="{ flex: h.flex }"
            >
                <approval-button v-if="h.key === 'approval_status'"
                    :approval_status="input['approval_status']"
                    :canEdit="true"
                    @action="_approveInput($event)"
                />
                <span v-else>{{ input[h.key] }}</span>
            </div>
        </div>

        <br><br>

        <div v-if="documents.length > 0"
            class="flex-all-centered-row headers"
        >
            <div v-for="h in document_headers" :key="h.key"
                :style="{ flex: h.flex }"
            >
                {{ h.text }}
            </div>
        </div>
        <div v-for="document in documents" :key="document.id" 
            class="flex-all-centered-row values"
        >
            <div v-for="h in document_headers" :key="h.key"
                :style="{ flex: h.flex }"
            >
                <approval-button v-if="h.key === 'approval_status'"
                    :approval_status="document['approval_status']"
                    :canEdit="true"
                    @action="_approveDocument($event, document)"
                />
                <button v-else-if="h.key === 'view'"
                    class="sust-btn sust-btn-green"
                    style="box-shadow: none;"
                    @click="viewDocument(document.id)"
                >
                    <i class="fa-solid fa-eye"></i>
                </button>
                <span v-else>{{ document[h.key] }}</span>
            </div>
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .headers, .values {
        padding: .5em;
        text-align: center;
    }

    .headers {
        background-color: var(--sustainfinity-navy);
        font-size: 1.05em;
        font-weight: bold;
        color: whitesmoke;
        border-top-left-radius: .5em;
        border-top-right-radius: .5em;
    }

    .values {
        background-color: rgb(230, 230, 230);
        font-size: 1em;
        border-bottom-left-radius: .5em;
        border-bottom-right-radius: .5em;
    }
</style>